import {
	IGetWatchInfo,
	ICreateWatch,
	IUpdateWatch,
	IGetPaginatedWatches,
	IWatches,
	IWatchNotificationsData,
	IGetRestaurantAndroidWatchesMessages,
	IRestaurantAndroidWatchesMessagesData,
} from 'types';
import { AxiosResponse } from 'axios';
import { request } from '../index';

const serviceGetWatchInfo = (watchID: string): Promise<IGetWatchInfo> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/v1/watches/${watchID}` });
};

const serviceCreateWatch = (data: ICreateWatch): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'postWithToken', url: '/api/v1/watches', data });
};

const serviceUpdateWatch = (data: IUpdateWatch): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: '/api/v1/watches', data });
};

const serviceGetPaginatedWatches = (args: IGetPaginatedWatches): Promise<AxiosResponse<IWatches>> => {
	return request({ typeOfRequest: 'postWithToken', url: '/api/v1/watches/filtered', data: args });
};

const serviceDeleteWatch = (watchID: string): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'deleteWithTokenAndWithParameterInUrlLine', url: `/api/v1/watches/${watchID}` });
};

const servicePushWatchNotifications = ({
	serialNumber,
	data,
}: {
	serialNumber: string;
	data: IWatchNotificationsData;
}): Promise<AxiosResponse<void>> => {
	return request({
		typeOfRequest: 'postWithToken',
		url: `/api/v1/watches/${serialNumber}/push-notifications:register`,
		data,
	});
};

const serviceGetRestaurantAndroidWatchesMessages = (
	restaurantID: string,
): Promise<IGetRestaurantAndroidWatchesMessages> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/v1/Restaurants/${restaurantID}/watches/messages` });
};

const serviceAssignRestaurantAndroidWatchesMessages = ({
	restaurantID,
	data,
}: {
	restaurantID: string;
	data: IRestaurantAndroidWatchesMessagesData;
}): Promise<AxiosResponse<void>> => {
	return request({
		typeOfRequest: 'postWithToken',
		url: `/api/v1/Restaurants/${restaurantID}/watches/messages:assign`,
		data,
	});
};

export {
	serviceGetWatchInfo,
	serviceCreateWatch,
	serviceUpdateWatch,
	serviceGetPaginatedWatches,
	serviceDeleteWatch,
	servicePushWatchNotifications,
	serviceGetRestaurantAndroidWatchesMessages,
	serviceAssignRestaurantAndroidWatchesMessages,
};
